import { GoalFilterDocument, GoalSortingMode, ID } from '@griply/types';
import {
  filterGoalsByFilterDocument,
  getWeekStartsOn,
  sortGoals,
} from '@griply/utils';
import { useSortedGoals } from 'features/goals';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';
import { sortGoalsHierarchically } from 'shared/utils/sort-goals-hierarchically';

export type Options = {
  customOrder?: ID[];
};

export const useGoalsByFilterDocument = (
  filterDocument: GoalFilterDocument | undefined,
  { customOrder }: Options,
) => {
  const sortedGoals = useSortedGoals();
  const user = useUser();
  const today = useToday();
  const weekStartsOn = getWeekStartsOn(user);

  return useMemo(() => {
    const filteredGoals = filterGoalsByFilterDocument(
      sortedGoals,
      filterDocument,
      { today, weekStartsOn },
    );

    if (customOrder?.length) {
      return sortGoalsHierarchically(filteredGoals, customOrder);
    }

    return sortGoals(filteredGoals, {
      allGoals: sortedGoals,
      sortMode: filterDocument?.sortingMode ?? GoalSortingMode.StartDate,
      customOrder,
    });
  }, [customOrder, filterDocument, sortedGoals, today, weekStartsOn]);
};
